// PROMPT...

import { slugify } from "@/lib/utils";

// please take this list of services associated with the industry and help me by:
// 1. combining like services into one. For example the "Tree Services" industry might have both "tree removal" and "shrub removal" as services. This can be combined into "tree and shrub removal"
// 2. This will be used to create SEO content around that service, so we don't want similar services as separate pages which could result in keyword cannabalization.
// 3. Make sure the list is around services a home service company would provide and is based on data that i give you. Do not make up anything for informational purposes. The intent should be aligned with someone who is looking for a home service company on Google.
// 3.5 Gift cards is not a service. don't include it.
// 4. return the data to me like so:

// [industryName]: [array of objects] with `label` (e.g. "tree and shrub removal" and `value` which should be a slug "tree-and-shrub-removal". List below

type Industry = {
  name: string;
  displayName: string;
  googleCategory: string;
  stockImages: string[];
};

type IndustryWithSlug = Industry & {
  slug: string;
};

type IndustryList = IndustryWithSlug[];

const carpetCleaningIndustry: Industry = {
  name: "carpet cleaning",
  displayName: "Carpet Cleaning",
  googleCategory: "Carpet cleaning service",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-completed/carpet-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-completed/carpet-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-completed/carpet-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-completed/carpet-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-completed/carpet-cleaning5.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-completed/carpet-cleaning6.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-completed/carpet-cleaning7.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-completed/carpet-cleaning8.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning5.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning6.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning7.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning8.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/job-progress/carpet-cleaning9.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/team/carpet-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/team/carpet-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/team/carpet-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/team/carpet-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/team/carpet-cleaning5.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/team/carpet-cleaning6.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/team/carpet-cleaning7.png",
    "https://ik.imagekit.io/4wu305uo4/carpet-cleaning/team/carpet-cleaning8.png",
  ],
};

const hvacIndustry: Industry = {
  name: "hvac",
  displayName: "HVAC",
  googleCategory: "HVAC contractor",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac1.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac2.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac3.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac4.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac5.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac6.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac7.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac8.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac9.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-completed/hvac10.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac1.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac2.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac3.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac4.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac5.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac6.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac7.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac8.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/job-progress/hvac9.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/team/hvac1.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/team/hvac2.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/team/hvac3.png",
    "https://ik.imagekit.io/4wu305uo4/hvac/team/hvac4.png",
  ],
};

const paintingIndustry: Industry = {
  name: "painting",
  displayName: "Painting",
  googleCategory: "Painter",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting1.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting2.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting3.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting4.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting5.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting6.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting7.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting8.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-completed/painting9.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-progress/painting1.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-progress/painting2.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-progress/painting3.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-progress/painting4.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-progress/painting5.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-progress/painting6.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-progress/painting7.png",
    "https://ik.imagekit.io/4wu305uo4/painting/job-progress/painting8.png",
    "https://ik.imagekit.io/4wu305uo4/painting/team/painting1.png",
    "https://ik.imagekit.io/4wu305uo4/painting/team/painting2.png",
    "https://ik.imagekit.io/4wu305uo4/painting/team/painting3.png",
    "https://ik.imagekit.io/4wu305uo4/painting/team/painting4.png",
    "https://ik.imagekit.io/4wu305uo4/painting/team/painting5.png",
  ],
};

const poolCleaningIndustry: Industry = {
  name: "pool cleaning",
  displayName: "Pool Cleaning",
  googleCategory: "Pool cleaning service",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-completed/pool-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-completed/pool-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-completed/pool-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-completed/pool-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-completed/pool-cleaning5.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-completed/pool-cleaning6.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-completed/pool-cleaning7.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-progress/pool-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-progress/pool-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-progress/pool-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-progress/pool-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-progress/pool-cleaning5.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-progress/pool-cleaning6.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-progress/pool-cleaning7.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/job-progress/pool-cleaning8.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/team/pool-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/team/pool-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/team/pool-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/team/pool-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/team/pool-cleaning5.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/team/pool-cleaning6.png",
    "https://ik.imagekit.io/4wu305uo4/pool-cleaning/team/pool-cleaning7.png",
  ],
};

const pressureWashingIndustry: Industry = {
  name: "pressure washing",
  displayName: "Pressure Washing",
  googleCategory: "Pressure washing service",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing1.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing2.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing3.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing4.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing5.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing6.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing7.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing8.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing9.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-completed/pressure-washing10.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-progress/pressure-washing1.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-progress/pressure-washing2.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-progress/pressure-washing3.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-progress/pressure-washing4.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-progress/pressure-washing5.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-progress/pressure-washing6.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-progress/pressure-washing7.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/job-progress/pressure-washing8.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/team/pressure-washing1.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/team/pressure-washing2.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/team/pressure-washing3.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/team/pressure-washing4.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/team/pressure-washing5.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/pw-2.png",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/pw-1.jpg",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/pw-3.jpg",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/pw-5.jpg",
    "https://ik.imagekit.io/4wu305uo4/pressure-washing/pw-4.jpg",
  ],
};

const treeServicesIndustry: Industry = {
  name: "tree services",
  displayName: "Tree Services",
  googleCategory: "Tree service",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services1.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services2.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services3.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services4.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services5.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services6.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services7.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services8.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-completed/tree-services9.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services1.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services2.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services3.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services4.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services5.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services6.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services7.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services8.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/job-progress/tree-services9.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/team/tree-services1.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/team/tree-services2.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/team/tree-services3.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/team/tree-services4.png",
    "https://ik.imagekit.io/4wu305uo4/tree-services/team/tree-services5.png",
  ],
};

const electricianIndustry: Industry = {
  name: "electrician",
  displayName: "Electrician",
  googleCategory: "Electrician",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/electrician/job-completed/electrician1.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-completed/electrician2.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-completed/electrician3.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-completed/electrician4.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-completed/electrician5.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-completed/electrician6.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-completed/electrician7.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-completed/electrician8.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-progress/electrician1.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-progress/electrician3.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-progress/electrician4.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-progress/electrician5.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/job-progress/electrician6.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/team/electrician1.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/team/electrician2.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/team/electrician3.png",
    "https://ik.imagekit.io/4wu305uo4/electrician/team/electrician4.png",
  ],
};

const carWashIndustry: Industry = {
  name: "car wash",
  displayName: "Car Wash",
  googleCategory: "Car wash",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-completed/car-wash1.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-completed/car-wash2.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-completed/car-wash3.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-completed/car-wash4.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-completed/car-wash5.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-completed/car-wash6.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-completed/car-wash7.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash1.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash2.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash3.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash4.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash5.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash6.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash7.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash8.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash9.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash10.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash11.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/job-progress/car-wash12.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/team/car-wash1.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/team/car-wash2.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/team/car-wash3.png",
    "https://ik.imagekit.io/4wu305uo4/car-wash/team/car-wash4.png",
  ],
};

const cleaningMaidServiceIndustry: Industry = {
  name: "cleaning / maid service",
  displayName: "Cleaning / Maid Service",
  googleCategory: "House cleaning service",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service1.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service2.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service3.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service4.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service5.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service6.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service7.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service8.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service9.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service10.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-completed/cleaning-maid-service11.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service1.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service2.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service3.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service4.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service5.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service6.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service7.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service8.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service9.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/job-progress/cleaning-maid-service10.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/team/cleaning-maid-service1.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/team/cleaning-maid-service2.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/team/cleaning-maid-service3.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/team/cleaning-maid-service4.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/team/cleaning-maid-service5.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/team/cleaning-maid-service6.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-maid-service/team/cleaning-maid-service7.png",
    "https://ik.imagekit.io/4wu305uo4/cleaning-1.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-2.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-3.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-4.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-5.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-6.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-7.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-8.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-9.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-10.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaning-11.jpg",
    "https://ik.imagekit.io/4wu305uo4/cleaing-12.jpg", // lol
  ],
};

const windowCleaningIndustry: Industry = {
  name: "window cleaning",
  displayName: "Window Cleaning",
  googleCategory: "Window cleaning service",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning5.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning6.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning7.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning8.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning9.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-completed/window-cleaning10.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-progress/window-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-progress/window-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-progress/window-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-progress/window-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-progress/window-cleaning5.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-progress/window-cleaning6.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-progress/window-cleaning7.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/job-progress/window-cleaning8.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/team/window-cleaning1.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/team/window-cleaning2.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/team/window-cleaning3.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/team/window-cleaning4.png",
    "https://ik.imagekit.io/4wu305uo4/window-cleaning/team/window-cleaning5.png",
  ],
};

const personalTrainerIndustry: Industry = {
  name: "personal trainer",
  displayName: "Personal Trainer",
  googleCategory: "Personal trainer",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-completed/personal-trainer1.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-completed/personal-trainer2.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-completed/personal-trainer3.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-completed/personal-trainer4.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-completed/personal-trainer5.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-completed/personal-trainer6.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-progress/personal-trainer1.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-progress/personal-trainer2.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-progress/personal-trainer3.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-progress/personal-trainer4.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-progress/personal-trainer5.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-progress/personal-trainer6.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/job-progress/personal-trainer7.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/team/personal-trainer1.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/team/personal-trainer2.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/team/personal-trainer3.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/team/personal-trainer4.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/team/personal-trainer5.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/team/personal-trainer6.png",
    "https://ik.imagekit.io/4wu305uo4/personal-trainer/team/personal-trainer7.png",
  ],
};

const pestControlIndustry: Industry = {
  name: "pest control",
  displayName: "Pest Control",
  googleCategory: "Pest control service",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-completed/pest-control1.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-completed/pest-control2.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-completed/pest-control3.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-completed/pest-control4.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-completed/pest-control5.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-completed/pest-control6.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-completed/pest-control7.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control1.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control2.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control3.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control4.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control5.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control6.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control7.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control8.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/job-progress/pest-control9.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/team/pest-control1.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/team/pest-control2.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/team/pest-control3.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/team/pest-control4.png",
    "https://ik.imagekit.io/4wu305uo4/pest-control/team/pest-control5.png",
  ],
};

const plumbingIndustry: Industry = {
  name: "plumbing",
  displayName: "Plumbing",
  googleCategory: "Plumber",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/plumbing/job-completed/plumbing1.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/job-completed/plumbing2.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/job-completed/plumbing3.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/job-completed/plumbing4.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/job-completed/plumbing5.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/job-progress/plumbing1.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/job-progress/plumbing2.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/job-progress/plumbing3.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/team/plumbing1.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/team/plumbing2.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/team/plumbing3.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/team/plumbing4.png",
    "https://ik.imagekit.io/4wu305uo4/plumbing/team/plumbing6.png",
  ],
};

const roofingIndustry: Industry = {
  name: "roofing",
  displayName: "Roofing",
  googleCategory: "Roofing contractor",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/roofing/job-completed/roofing1.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-completed/roofing2.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-completed/roofing3.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-completed/roofing4.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-completed/roofing5.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-completed/roofing6.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-completed/roofing7.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-completed/roofing8.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-progress/roofing1.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-progress/roofing2.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-progress/roofing3.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-progress/roofing4.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-progress/roofing5.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-progress/roofing6.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-progress/roofing7.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/job-progress/roofing8.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/team/roofing1.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/team/roofing2.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/team/roofing3.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/team/roofing4.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/team/roofing5.png",
    "https://ik.imagekit.io/4wu305uo4/roofing/team/roofing6.png",
  ],
};

const movingIndustry: Industry = {
  name: "moving",
  displayName: "Moving",
  googleCategory: "Moving and storage service",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/moving/job-completed/moving1.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-completed/moving2.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-completed/moving3.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-completed/moving4.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-completed/moving5.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-completed/moving6.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-completed/moving7.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-completed/moving8.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving2.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving3.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving4.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving5.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving6.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving7.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving8.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving9.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving10.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving11.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving12.png",
    "https://ik.imagekit.io/4wu305uo4/moving/job-progress/moving13.png",
    "https://ik.imagekit.io/4wu305uo4/moving/team/moving1.png",
    "https://ik.imagekit.io/4wu305uo4/moving/team/moving2.png",
    "https://ik.imagekit.io/4wu305uo4/moving/team/moving3.png",
    "https://ik.imagekit.io/4wu305uo4/moving/team/moving4.png",
    "https://ik.imagekit.io/4wu305uo4/moving/team/moving5.png",
    "https://ik.imagekit.io/4wu305uo4/moving/team/moving6.png",
    "https://ik.imagekit.io/4wu305uo4/moving/team/moving7.png",
  ],
};

const homeRemodelingIndustry: Industry = {
  name: "home remodeling",
  displayName: "Home Remodeling",
  googleCategory: "Remodeler",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-completed/home-remodeling1.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-completed/home-remodeling2.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-completed/home-remodeling3.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-completed/home-remodeling4.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-completed/home-remodeling5.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-completed/home-remodeling6.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-completed/home-remodeling7.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-progress/home-remodeling1.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-progress/home-remodeling2.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-progress/home-remodeling3.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-progress/home-remodeling4.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/job-progress/home-remodeling5.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/team/home-remodeling1.png",
    "https://ik.imagekit.io/4wu305uo4/home-remodeling/team/home-remodeling2.png",
  ],
};

const landscapingIndustry: Industry = {
  name: "landscaping",
  displayName: "Landscaping",
  googleCategory: "Landscaper",
  stockImages: [
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping1.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping2.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping3.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping4.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping5.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping6.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping7.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping8.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping9.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-completed/landscaping10.png?updatedAt=1727376523061",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping1.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping2.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping3.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping4.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping5.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping6.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping7.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping8.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping9.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/job-progress/landscaping10.png?updatedAt=1727376765515",
    "https://ik.imagekit.io/4wu305uo4/landscaping/team/landscaping1.png?updatedAt=1727376901411",
    "https://ik.imagekit.io/4wu305uo4/landscaping/team/landscaping2.png?updatedAt=1727376901411",
    "https://ik.imagekit.io/4wu305uo4/landscaping/team/landscaping3.png?updatedAt=1727376901411",
    "https://ik.imagekit.io/4wu305uo4/landscaping/team/landscaping4.png?updatedAt=1727376901411",
    "https://ik.imagekit.io/4wu305uo4/landscaping/team/landscaping5.png?updatedAt=1727376901411",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping1.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping2.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping3.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping4.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping5.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping6.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping8.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping9.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping10.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping11.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping12.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping7.jpg",
    "https://ik.imagekit.io/4wu305uo4/landscaping/landscaping13.jpg",
  ],
};

const junkRemovalIndustry: Industry = {
  name: "junk removal",
  displayName: "Junk Removal",
  googleCategory: "Debris removal service",
  stockImages: ["https://ik.imagekit.io/4wu305uo4/junk-removal/job-progress/junk-removal2.png"], // TODO: add more stock images
};

export const defaultIndustryList: IndustryList = [
  carpetCleaningIndustry,
  hvacIndustry,
  paintingIndustry,
  poolCleaningIndustry,
  pressureWashingIndustry,
  treeServicesIndustry,
  electricianIndustry,
  carWashIndustry,
  cleaningMaidServiceIndustry,
  windowCleaningIndustry,
  personalTrainerIndustry,
  pestControlIndustry,
  plumbingIndustry,
  roofingIndustry,
  movingIndustry,
  homeRemodelingIndustry,
  landscapingIndustry,
  junkRemovalIndustry,
].map((industry) => ({
  ...industry,
  slug: slugify(industry.name), // generate slugs for each industry
}));

export const DEFAULT_INDUSTRIES_LIST = defaultIndustryList.map((industry) => industry.displayName);

export const INDUSTRY_SLUGS = defaultIndustryList.map((industry) => ({
  label: industry.displayName,
  slug: industry.slug,
}));

export const INDUSTRY_SUGGESTIONS_BASE_URL = "https://google-categories.vercel.app/api/categories/";
